<template>
  <section>
    <div class="wrapper">
      <h1>404 Not Found</h1>
      <el-button
        type="primary"
        @click="backToHome">Back to Home</el-button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    backToHome() {
      this.$router.push({ path: '/' })
    },
  },
}
</script>

<style lang="scss" scoped>
section {
  height: 100vh;
  display: flex;
  justify-content: center;
  .wrapper {
    margin: 20px;
    margin-top: 15vh;
    button {
      width: 100%;
      max-width: 200px;
    }
  }
}
</style>

